import { Route, Navigate } from "react-router-dom";
import { ProtectedRoute, OfficerRoute, PermRoute } from "@/components/RouteGuards";
import SetPassword from "@/pages/SetPassword";
import PublicLayout from "@/components/PublicLayout";
import PortalLayout from "@/components/PortalLayout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/public/Home";
import { About, Membership } from "@/pages/public/StaticPages";
import { Leadership, Chapters, Welfare, Gallery, Constitution } from "@/pages/public/DataPages";
import { EventsPublic, EventDetail, FAQ, Contact } from "@/pages/public/EventsAndContact";
import Registration from "@/pages/public/Registration";
import Connect from "@/pages/public/Connect";
import { Privacy, Terms, Cookies } from "@/pages/public/Policies";
import { NewsletterArchive, NewsletterIssue } from "@/components/NewsletterPages";
import NewsletterAdmin from "@/pages/admin/NewsletterAdmin";
import Help from "@/pages/portal/Help";
import { AboutPage } from "@/components/About";
import { Login, ForgotPassword, ResetPassword } from "@/pages/Auth";
import * as P from "@/pages/portal/PortalPages";
import CheckIn from "@/pages/portal/CheckIn";
import * as A from "@/pages/admin/AdminPages";
import { ContentAdmin, MeetingsAdmin, MeetingDetail } from "@/pages/admin/AdminPlus";
import FinanceModule from "@/pages/admin/FinanceModule";
import CronHealth from "@/pages/admin/CronHealth";

const PUBLIC = [["/", <Home />], ["/about", <About />], ["/about/leadership", <Leadership />], ["/chapters", <Chapters />],
  ["/constitution", <Constitution />], ["/membership", <Membership />], ["/events", <EventsPublic />], ["/events/:id", <EventDetail />],
  ["/gallery", <Gallery />], ["/welfare", <Welfare />], ["/contact/faq", <FAQ />], ["/contact", <Contact />], ["/contact/connect", <Connect />],
  ["/registration", <Registration />], ["/privacy", <Privacy />], ["/terms", <Terms />], ["/cookies", <Cookies />],
  ["/newsletter", <NewsletterArchive />], ["/newsletter/:slug", <NewsletterIssue />]];
const REDIRECTS = [["/leadership", "/about/leadership"], ["/faq", "/contact/faq"], ["/connect", "/contact/connect"], ["/apply", "/registration"], ["/register", "/registration"]];
const PORTAL = [["standing", <P.Standing />], ["dues", <P.Dues />], ["payments", <P.Payments />], ["events", <P.MemberEvents />], ["welfare", <P.MemberWelfare />],
  ["directory", <P.Directory />], ["documents", <P.Documents />], ["elections", <P.Elections />], ["notifications", <P.Notifications />], ["profile", <P.Profile />], ["help", <Help />],
  ["newsletter", <NewsletterArchive base="/portal/newsletter" hero={false} />], ["newsletter/:slug", <NewsletterIssue base="/portal/newsletter" hero={false} />]];
// [path, element, required permission]
const ADMIN = [["reconciliation", <A.Reconciliation />, "finance"], ["members", <A.MembersAdmin />], ["dues", <A.DuesAdmin />, "finance"],
  ["welfare", <A.WelfareAdmin />, "welfare"], ["events", <A.EventsAdmin />, "events"], ["meetings", <MeetingsAdmin />, "events"],
  ["meetings/:id", <MeetingDetail />, "events"], ["content", <ContentAdmin />, "content_manage"], ["communications", <A.Communications />, "broadcast"],
  ["elections", <A.ElectionsAdmin />, "elections"], ["finance", <A.Finance />, "finance"], ["money", <FinanceModule />, "finance"], ["roles", <A.RolesAdmin />, "admin_level"],
  ["audit", <A.AuditLog />, "admin_level"], ["cron", <CronHealth />, "admin_level"], ["about", <AboutPage />],
  ["newsletter", <NewsletterAdmin />, "newsletter"], ["newsletter/:id", <NewsletterAdmin />, "newsletter"]];

export const publicRoutes = (
  <>
    <Route element={<PublicLayout />}>
      {PUBLIC.map(([p, el]) => <Route key={p} path={p} element={el} />)}
    </Route>
    {REDIRECTS.map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/set-password" element={<ProtectedRoute><SetPassword /></ProtectedRoute>} />
    <Route path="/checkin/:token" element={<ProtectedRoute><CheckIn /></ProtectedRoute>} />
  </>
);

export const portalRoutes = (
  <Route path="/portal" element={<ProtectedRoute><PortalLayout /></ProtectedRoute>}>
    <Route index element={<P.Dashboard />} />
    {PORTAL.map(([p, el]) => <Route key={p} path={p} element={el} />)}
  </Route>
);

export const adminRoutes = (
  <Route path="/admin" element={<OfficerRoute><AdminLayout /></OfficerRoute>}>
    <Route index element={<A.Overview />} />
    {ADMIN.map(([p, el, perm]) => <Route key={p} path={p} element={perm ? <PermRoute perm={perm}>{el}</PermRoute> : el} />)}
  </Route>
);
